import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import * as Sentry from "@sentry/angular-ivy";
import packageJson from "../package.json";
import {
  ErrorHint,
  combinedMessageRegex,
  ignoredErrors,
} from "./sentryIgnoredErrors";

const shouldIgnoreError = (error?: ErrorHint["originalException"]): boolean => {
  if (!error) return false;

  for (const rule of ignoredErrors) {
    if (
      (rule?.status !== undefined && error?.status === rule?.status) ||
      (rule?.message && error?.message?.includes(rule?.message))
    ) {
      return true;
    }
  }
  return error?.message ? combinedMessageRegex?.test(error?.message) : false;
};

Sentry.init({
  dsn: environment.sentryDsn,
  release: packageJson.version,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.2, //  Capture 20% of the transactions
  beforeSend(event, hint) {
    return shouldIgnoreError(hint?.originalException) ? null : event;
  },
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
